import React from 'react';
import { useTranslation } from 'react-i18next';
import { AnimateOnScroll } from './AnimateOnScroll';
import './Pricing.css';

const Pricing = () => {
  const { t } = useTranslation();
  
  const plans = [
    {
      name: t('pricing.free.name'),
      price: t('pricing.free.price'),
      period: t('pricing.free.period'),
      description: t('pricing.free.description'),
      features: t('pricing.free.features', { returnObjects: true }),
      cta: t('pricing.free.cta'),
      trial: null,
      highlighted: false
    },
    {
      name: t('pricing.premium.name'),
      price: t('pricing.premium.price'),
      period: t('pricing.premium.period'),
      priceYearly: t('pricing.premium.priceYearly'),
      periodYearly: t('pricing.premium.periodYearly'),
      description: t('pricing.premium.description'),
      features: t('pricing.premium.features', { returnObjects: true }),
      cta: t('pricing.premium.cta'),
      trial: t('pricing.trial'),
      highlighted: true
    },
    {
      name: t('pricing.premiumPlus.name'),
      price: t('pricing.premiumPlus.price'),
      period: t('pricing.premiumPlus.period'),
      priceYearly: t('pricing.premiumPlus.priceYearly'),
      periodYearly: t('pricing.premiumPlus.periodYearly'),
      description: t('pricing.premiumPlus.description'),
      features: t('pricing.premiumPlus.features', { returnObjects: true }),
      cta: t('pricing.premiumPlus.cta'),
      trial: t('pricing.trial'),
      highlighted: false
    }
  ];
  return (
    <section id="pricing" className="pricing">
      <div className="pricing__container">
        <AnimateOnScroll animation="fadeUp">
          <div className="pricing__header">
            <span className="pricing__label">{t('pricing.label')}</span>
            <h2 className="pricing__title">{t('pricing.title')}</h2>
            <p className="pricing__subtitle">
              {t('pricing.subtitle')}
            </p>
          </div>
        </AnimateOnScroll>
        
        <div className="pricing__grid">
          {plans.map((plan, index) => (
            <AnimateOnScroll key={index} animation="fadeUp" delay={index * 0.15}>
              <article className={`pricing-card ${plan.highlighted ? 'pricing-card--highlighted' : ''}`}>
                {plan.highlighted && <div className="pricing-card__badge">{t('pricing.badge')}</div>}
                <div className="pricing-card__header">
                  <h3 className="pricing-card__name">{plan.name}</h3>
                  <div className="pricing-card__price">
                    <span className="pricing-card__amount">{plan.price}</span>
                    <span className="pricing-card__period">{plan.period}</span>
                  </div>
                  {plan.priceYearly && (
                    <div className="pricing-card__price-yearly">
                      <span className="pricing-card__amount-yearly">{plan.priceYearly}</span>
                      <span className="pricing-card__period-yearly">{plan.periodYearly}</span>
                    </div>
                  )}
                  {plan.trial && (
                    <p className="pricing-card__trial">{plan.trial}</p>
                  )}
                  <p className="pricing-card__description">{plan.description}</p>
                </div>
                
                <ul className="pricing-card__features">
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="pricing-card__feature">
                      <svg className="pricing-card__check" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.667 5L7.5 14.167 3.333 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>
                
                <a href="#download" className={`pricing-card__cta ${plan.highlighted ? 'pricing-card__cta--primary' : 'pricing-card__cta--secondary'}`}>
                  {plan.cta}
                </a>
              </article>
            </AnimateOnScroll>
          ))}
        </div>
      </div>
    </section>
  );
};

export default React.memo(Pricing);
